module.exports = __webpack_public_path__ + "img/uncheckedIcon.60258262.svg";